import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { FileCopy as FileCopyBase } from '@mui/icons-material'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
`

export const Subtitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: bold;
  line-height: 21px;
  margin: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const Key = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
`

export const Value = styled('div')`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  color: ${props => props.theme.palette.brand.black2};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  text-decoration: underline;
  font-size: 14px;
  line-height: 24px;
  word-break: break-all;
`

export const MiniClipboardIcon = styled(FileCopyBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black2};
    font-size: 1rem;
    margin: 0 0 0 16px;

    &:hover {
      fill: ${props => props.theme.palette.brand.black1};
      cursor: pointer;
    }
  }
`

export const Clipboard = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.black1};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 45px;
  max-width: 670px;
  padding: 4px 0 4px 16px;
  width: 100%;
`

export const ClipboardText = styled('div')`
  color: ${props => props.theme.palette.brand.white};
  font-family: Coda;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  pointer-events: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

export const ClipboardAction = styled('div')`
  display: flex;
  justify-content: center;
  pointer-events: none;
  user-select: none;
`

export const ClipboardIcon = styled(FileCopyBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    font-size: 1.1rem;
    pointer-events: none;
    user-select: none;
  }
`
export const Label = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  margin: 0;
`

export const List = styled('ul')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 21px;
  margin: 0;
  padding: 0 0 0 30px;
`

export const Item = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: ${props => props.margin};
`
export const Strong = styled('strong')``

export const OrderedList = styled('ol')`
  margin: 20px 0;
  padding-left: 20px;
  font-family: Arial, sans-serif;
`
export const UnorderedList = styled('ul')`
  margin: 10px 0;
`
export const ListItem = styled('li')`
  margin: 5px 0;
  font-size: 14px;
`

export const Break = styled('br')`
  margin: 16px 0;
`
